function filterByTypename<
  K extends string,
  N extends K,
  T extends { __typename?: K },
>(array: T[], typename: N): Extract<T, { __typename?: N }>[] {
  return array.filter(
    (item): item is Extract<T, { __typename?: N }> =>
      item.__typename === typename || item.__typename === undefined,
  );
}

function omitNonTopics<T extends { __typename?: string }>(topics: T[]) {
  return filterByTypename(topics, 'Topic');
}

export default omitNonTopics;
